import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@/shared/ui';

const AppVersion = () => {
  const appVersion = import.meta.env.VITE_REACT_APP_VERSION;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <InfoOutlined sx={{ fontSize: 14, color: 'gx.textDisabled' }} />
      <Typography
        sx={{ color: 'gx.textDisabled' }}
        variant='body2'
      >
        GX Go app version {appVersion}
      </Typography>
    </Box>
  );
};

export default AppVersion;
